// lib/arenaStorage.js
import { getDatabase, ref, set, push, onValue, off, update, remove, onDisconnect, get } from 'firebase/database';
import { app } from '../firebase';

const rtdb = getDatabase(app);

// 1. Hızlı Maç Bul veya Oda Oluştur (Matchmaking)
export async function findOrCreateMatch(userProfile, onMatchFound) {
  const lobbyRef = ref(rtdb, 'lobby');
  const userLobbyRef = ref(rtdb, `lobby/${userProfile.uid}`);

  try {
    const snapshot = await get(lobbyRef);
    const lobbyData = snapshot.val() || {};

    const opponentUid = Object.keys(lobbyData).find(
      (uid) => uid !== userProfile.uid && !lobbyData[uid].roomId
    );

    if (opponentUid) {
      const opponent = lobbyData[opponentUid];
      const newRoomRef = push(ref(rtdb, 'rooms'));
      const roomId = newRoomRef.key;

      const isUserSente = Math.random() < 0.5;

      const roomPayload = {
        status: 'playing',
        createdAt: Date.now(),
        turn: 'sente',
        players: {
          sente: isUserSente ? userProfile : { uid: opponent.uid, nickname: opponent.nickname, photoURL: opponent.photoURL },
          gote: isUserSente ? { uid: opponent.uid, nickname: opponent.nickname, photoURL: opponent.photoURL } : userProfile
        },
        lastMove: null,
        winner: null
      };

      await set(newRoomRef, roomPayload);

      await update(ref(rtdb, `lobby/${opponentUid}`), {
        roomId,
        role: isUserSente ? 'gote' : 'sente'
      });

      await remove(userLobbyRef);

      onMatchFound({ roomId, role: isUserSente ? 'sente' : 'gote' });
    } else {
      await set(userLobbyRef, {
        uid: userProfile.uid,
        nickname: userProfile.nickname,
        photoURL: userProfile.photoURL || '',
        createdAt: Date.now(),
        roomId: null
      });

      onDisconnect(userLobbyRef).remove();

      const unsubscribe = onValue(userLobbyRef, (snap) => {
        const data = snap.val();
        if (data && data.roomId) {
          off(userLobbyRef);
          remove(userLobbyRef);
          onMatchFound({ roomId: data.roomId, role: data.role });
        }
      });
    }
  } catch (error) {
    console.error('Matchmaking Hatası:', error);
  }
}

// 🎯 YENİ EKLENEN: Lobide bekleyen oyuncuları canlı dinler
export function subscribeToWaitingPlayers(callback) {
  const lobbyRef = ref(rtdb, 'lobby');
  onValue(lobbyRef, (snapshot) => {
    const data = snapshot.val() || {};
    // roomId atanmamış olanlar bekleyen oyunculardır
    const waitingUids = Object.keys(data).filter((uid) => !data[uid].roomId);
    callback(waitingUids.length > 0, waitingUids.length);
  });
  return () => off(lobbyRef);
}

// 2. Odayı Canlı (Realtime) Dinle
export function subscribeToRoom(roomId, callback) {
  const roomRef = ref(rtdb, `rooms/${roomId}`);
  onValue(roomRef, (snapshot) => {
    callback(snapshot.val());
  });
  return () => off(roomRef);
}

// 3. Odaya Hamle Gönder
export async function sendOnlineMove(roomId, moveRecord, nextTurn) {
  const roomRef = ref(rtdb, `rooms/${roomId}`);
  await update(roomRef, {
    lastMove: moveRecord,
    turn: nextTurn,
    updatedAt: Date.now()
  });
}

// 4. Maç Sonucunu Odaya Yaz
export async function finishOnlineMatch(roomId, winnerRole, reason) {
  const roomRef = ref(rtdb, `rooms/${roomId}`);
  await update(roomRef, {
    status: 'finished',
    winner: winnerRole,
    reason,
    finishedAt: Date.now()
  });
}